import React, { useMemo } from 'react';
import { useModuleSettings } from '../../contexts/ModuleSettingsContext';
import { getQuantityConversionHint } from '../../utils/unitSelectUtils';

const QuantityConversionHint = ({ product = null, unitCode = '', quantity = '' }) => {
  const { productConversionsEnabled } = useModuleSettings();

  const hint = useMemo(
    () =>
      getQuantityConversionHint({
        product,
        unitCode,
        quantity,
        productConversionsEnabled,
      }),
    [product, unitCode, quantity, productConversionsEnabled],
  );

  if (!hint) return null;

  return (
    <span className="text-teal-700 whitespace-nowrap" title={hint.text}>
      {hint.text}
    </span>
  );
};

export default QuantityConversionHint;
